

export const DEFAULT_APPOINTMENT_DURATION = 1;